import { Button } from '../../components/Button';
import { ItemCard } from '../../components/ItemCard';
import { CardWrapper, EditLink, QuantityText, SelectedInfo } from './ExtrasCard.styles';
import type { ExtrasCardProps } from './ExtrasCard.types';

export function ExtrasCard({
  image,
  imageAspectRatio,
  title,
  price,
  selected = false,
  quantity,
  onAdd,
  onRemove,
  onEditSelections,
  labels = {},
}: ExtrasCardProps) {
  const {
    add = 'Add',
    remove = 'Remove',
    quantity: quantityLabel = 'Quantity',
    editSelections = 'Edit selections',
    noImage = 'No image',
  } = labels;

  const customAction = (
    <Button
      type="button"
      variant={selected ? 'outline' : 'primary'}
      size="small"
      onClick={selected ? onRemove : onAdd}
    >
      {selected ? remove : add}
    </Button>
  );

  const meta =
    selected && quantity ? (
      <SelectedInfo>
        <QuantityText>{`${quantityLabel} ${quantity}`}</QuantityText>
        {onEditSelections && (
          <EditLink type="button" onClick={onEditSelections}>
            {editSelections}
          </EditLink>
        )}
      </SelectedInfo>
    ) : undefined;

  return (
    <CardWrapper>
      <ItemCard
        image={{ ...image, placeholderLabel: image.placeholderLabel ?? noImage }}
        imageAspectRatio={imageAspectRatio}
        title={title}
        price={price}
        customAction={customAction}
        meta={meta}
      />
    </CardWrapper>
  );
}
